export const DEMO_ADDRESS = "0xb464b1ab500960d46e0a39cb52cd5551a43040a2";
export const DEMO_USER = {
  fid: 19,
  username: "username-test",
  displayName: "displayname-test",
  pfpUrl:
    "https://imagedelivery.net/BXluQx4ige9GuW0Ia56BHw/1b8eab7e-1801-4205-b420-d6fa5a080800/original",
  location: {
    placeId: "",
    description: "",
  },
};
